<form #customerForm="ngForm" (ngSubmit)="saveCustomer(customerForm)" class="p-20">
  <div class="content">
    <div class="row">
      <h5 class="col-sm-9" i18n>Customer Information</h5>
      <div class="col-sm-3">
        <div class="warning" i18n>* Required Information</div>
      </div>
    </div>
    <div class="form-group row">
      <div class="d-flex flex-row">
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label for="customer_BusinessName" class="col-form-label" i18n>Customer Name</label>
          <input name="customer_BusinessName" id="customer_BusinessName" type="text" class="form-control"
                 required maxlength="50"
                 [attr.disabled]="readOnly ? '' : null"
                 [(ngModel)]="customer.customer_BusinessName" #customer_BusinessName="ngModel">
          <div [hidden]="!customerForm.submitted || customer_BusinessName.valid"
               class="alert alert-danger" i18n>Enter a business name</div>
        </div>
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label for="customerType_ID" class="col-form-label" i18n>Customer Type</label>
          <select name="customerType_ID" id="customerType_ID" class="form-control select-bidit"
                  required
                  [attr.disabled]="readOnly ? '' : null"
                  [(ngModel)]="customer.customerType_ID" #customerType_ID="ngModel">
            <option [ngValue]="undefined">-</option>
            <option *ngFor="let customerType of customerTypes" [ngValue]="customerType.customerType_ID">{{customerType.customerType_Desc}}</option>
          </select>
          <div [hidden]="!customerForm.submitted || customerType_ID.valid"
               class="alert alert-danger" i18n>Enter a customer type</div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="customer_ID" class="col-sm-2 col-form-label" i18n>Customer Address</label>
      <div class="col-sm-10">
        <table class="table table-bidit">
          <thead>
            <tr>
              <td i18n>Address</td>
              <td i18n>Address (2)</td>
              <td i18n>City</td>
              <td i18n>State</td>
              <td i18n>Zip</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="warning">* </span>
                <input type="text" name="customer_Address1" id="customer_Address1"
                       class="form-control float-right" style="width: 95%;"
                       [attr.disabled]="readOnly ? '' : null"
                       required=""
                       [(ngModel)]="customer.customer_Address1" #customer_Address1="ngModel" />
              </td>
              <td>
                <input type="text" name="customer_Address2" id="customer_Address2" class="form-control"
                       [attr.disabled]="readOnly ? '' : null"
                       [(ngModel)]="customer.customer_Address2" #customer_Address2="ngModel" />
              </td>
              <td>
                <span class="warning">* </span>
                <input type="text" name="customer_City" id="customer_City"
                       class="form-control float-right" style="width: 95%;"
                       [attr.disabled]="readOnly ? '' : null"
                       required=""
                       [(ngModel)]="customer.customer_City" #customer_City="ngModel" />
              </td>
              <td style="width: 115px;">
                <span class="warning">* </span>
                <select name="customer_State" id="customer_State" class="form-control select-bidit state-select float-right"
                        [attr.disabled]="readOnly ? '' : null"
                        required=""
                        [(ngModel)]="customer.customer_State" #customer_State="ngModel">
                  <option value="">-</option>
                  <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
                </select>
              </td>
              <td>
                <span class="warning">* </span>
                <input type="text" name="customer_Postal" id="customer_Postal"
                       class="form-control float-right" style="width: 95%;"
                       [attr.disabled]="readOnly ? '' : null"
                       required=""
                       [(ngModel)]="customer.customer_Postal" #customer_Postal="ngModel" />
              </td>
            </tr>
          </tbody>
        </table>
        <div [hidden]="!customerForm.submitted || (customer_Address1.valid && customer_City.valid && customer_State.valid && customer_Postal.valid)"
             class="alert alert-danger" i18n>Customer Address Required</div>
      </div>
    </div>
    <div *ngIf="customer.customer_ID == null" class="form-group row">
      <label for="customer_ID" class="col-sm-2 col-form-label" i18n>Contact Details</label>
      <div class="col-sm-10">
        <table class="table table-bidit">
          <thead>
            <tr>
              <td i18n>Contact First Name</td>
              <td i18n>Contact Last Name</td>
              <td i18n>Phone #</td>
              <td i18n>Cell #</td>
              <td i18n>Email</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="warning">* </span>
                <input type="text" name="contact_FirstName" id="contact_FirstName"
                       class="form-control float-right" style="width: 95%;"
                       required
                       [attr.disabled]="readOnly ? '' : null"
                       [(ngModel)]="customer.contact_FirstName" #contact_FirstName="ngModel" />
              </td>
              <td>
                <span class="warning">* </span>
                <input type="text" name="contact_LastName" id="contact_LastName"
                       class="form-control float-right" style="width: 95%;"
                       required
                       [attr.disabled]="readOnly ? '' : null"
                       [(ngModel)]="customer.contact_LastName" #contact_LastName="ngModel" />
              </td>
              <td>
                <input type="text" name="contact_Phone" id="contact_Phone"
                       placeholder="555-555-5555" appPhoneMask
                       class="form-control float-right" style="width: 95%;"
                       [attr.disabled]="readOnly ? '' : null"
                       [(ngModel)]="customer.contact_Phone" #contact_Phone="ngModel" />
              </td>
              <td>
                <input type="text" name="contact_Mobile" id="contact_Mobile"
                       placeholder="555-555-5555" appPhoneMask
                       class="form-control float-right" style="width: 95%"
                       [attr.disabled]="readOnly ? '' : null"
                       [(ngModel)]="customer.contact_Mobile" #contact_Mobile="ngModel" />
              </td>
              <td>
                <input type="text" name="contact_Email" id="contact_Email"
                       class="form-control float-right" style="width: 95%"
                       [attr.disabled]="readOnly ? '' : null"
                       [(ngModel)]="customer.contact_Email" #contact_Email="ngModel" />
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="form-inline">
                  <div class="control-wrapper">
                    <span class="warning">* </span>
                    <label for="customerType_ID" class="col-form-label" i18n>Contact Type</label>
                    <select name="contactType_ID" id="contactType_ID" class="form-control select-bidit"
                            required
                            [attr.disabled]="readOnly ? '' : null"
                            [(ngModel)]="customer.contactType_ID" #contactType_ID="ngModel">
                      <option [ngValue]="undefined">-</option>
                      <option *ngFor="let contactType of contactTypes" [ngValue]="contactType.contactType_ID">{{contactType.contactType_Desc}}</option>
                    </select>
                    <div [hidden]="!customerForm.submitted || contactType_ID.valid"
                         class="alert alert-danger" i18n>Enter a contact type</div>
                  </div>
                </div>
              </td>
              <td colspan="3">
                <span class="warning" i18n>* Either Phone #, Cell #, or Email address is required</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div [hidden]="!customerForm.submitted || (contact_FirstName.valid && contact_LastName.valid)"
             class="alert alert-danger" i18n>Contact First and Last Name Required</div>
        <div [hidden]="!customerForm.submitted ||
             ((contact_Phone.value != null && contact_Phone.value != '') ||
             (contact_Mobile.value != null && contact_Mobile.value != '') ||
             (contact_Email.value != null && contact_Email.value != ''))"
             class="alert alert-danger" i18n>Contact Phone or Email Required</div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12 form-inline">
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label for="customer_AssignedTo" class="col-form-label" i18n>Salesperson</label>
          <select name="customer_AssignedTo" id="customer_AssignedTo"
                  class="form-control select-bidit" required
                  [attr.disabled]="readOnly ? '' : null"
                  [(ngModel)]="customer.customer_AssignedTo" #customer_AssignedTo="ngModel">

            <option value="" selected="">-</option>
            <option *ngFor="let salesperson of salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
          </select>
          <div [hidden]="!customerForm.submitted || customer_AssignedTo.valid"
               class="alert alert-danger" i18n>Enter a salesperson</div>
        </div>
        <div class="control-wrapper">
          <span class="warning">* </span>
          <label for="office_ID" class="col-form-label" i18n>Office</label>
          <select name="office_ID" id="office_ID"
                  class="form-control select-bidit" required
                  [attr.disabled]="readOnly ? '' : null"
                  [(ngModel)]="customer.office_ID" #office_ID="ngModel">

            <option [ngValue]="undefined" selected="">-</option>
            <option *ngFor="let office of offices" [ngValue]="office.office_ID">{{office.office_Name}}</option>
          </select>
          <div [hidden]="!customerForm.submitted || office_ID.valid"
               class="alert alert-danger" i18n>Enter an office</div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12 form-inline">
        <div class="control-wrapper">
          <label for="paymentType_ID" i18n>Payment Type</label>
          <select name="paymentType_ID" id="paymentType_ID" class="form-control select-bidit"
                  [attr.disabled]="readOnly ? '' : null"
                  [(ngModel)]="customer.paymentType_ID" #paymentType_ID="ngModel">

            <option [ngValue]="undefined" selected="">-</option>
            <option *ngFor="let paymentType of paymentTypes" [ngValue]="paymentType.paymentType_ID">{{paymentType.paymentType_Desc}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="paymentTerm_ID" i18n>Payment Terms</label>
          <select name="paymentTerm_ID" id="paymentTerm_ID" class="form-control select-bidit"
                  [attr.disabled]="readOnly ? '' : null"
                  [(ngModel)]="customer.paymentTerm_ID" #paymentTerm_ID="ngModel">

            <option [ngValue]="undefined" selected="">-</option>
            <option *ngFor="let paymentTerm of paymentTerms" [ngValue]="paymentTerm.paymentTerm_ID">{{paymentTerm.paymentTerm_Desc}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="customer_Margin" class="col-form-label" i18n>Default Gross Margin %</label>
          <input name="customer_Margin" type="number" class="form-control"
                 [(ngModel)]="customer.customer_Margin" #customer_Margin="ngModel">
        </div>
      </div>
    </div>

    <div *ngIf="readOnly == false" class="row">
      <div class="col-md-12">
        <div *ngIf="!isRequesting" align="right">
          <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit" i18n>Submit</button>
          <button type="button" class="btn btn-bidit-cancel" (click)="cancelEdit()" i18n>Cancel</button>
          <div [hidden]="!customerForm.submitted || customerForm.valid"
               class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
    </div>
  </div>
</form>
